export class JobQualificationRequirement {
    private constructor(
        public readonly id: number,
        public readonly description: string
    ) {}

    public static Met = new JobQualificationRequirement(10, "met");
    public static NotMet = new JobQualificationRequirement(20, "notMet");
    public static NotAnswered = new JobQualificationRequirement(
        30,
        "notAnswered"
    );

    public isMet = () => this === JobQualificationRequirement.Met;
    public isNotMet = () => this === JobQualificationRequirement.NotMet;
    public isNotAnswered = () =>
        this === JobQualificationRequirement.NotAnswered;

    public static asArray = () => [
        JobQualificationRequirement.Met,
        JobQualificationRequirement.NotMet,
        JobQualificationRequirement.NotAnswered,
    ];

    public static fromId = (id: number) =>
        JobQualificationRequirement.asArray().find(r => r.id === id);
}
